<template>
  <b-row>
    <b-col xl="8" md="7">
      <el-collapse v-model="activeNames">
        <b-row>
          <b-col lg="6" md="12" class="">
            <el-collapse-item title="Biểu đồ sự kiện tháng" name="1" class="chart">
              <template slot="title">
                <h6 class="ml-1 title-chart bold">Biểu đồ sự kiện tháng</h6>
              </template>
              <div @click="fn_goToEntryAndExitHistoryCompanyList">
                <!-- <EChart
                  :optionChart="optionChartEventMonth"
                  :heightChart="'320'"
                  :chartId="'EventMonth'"
                  :newData="newDataProp"
                /> -->
                <ChartJS
                  v-if="loaded"
                  :idChart="'EventMonth'"
                  :typeChart="'bar'"
                  :chartdata="chartdataEventMonth"
                  :options="chartOptions"
                />
              </div>
            </el-collapse-item>
          </b-col>
          <b-col lg="6" md="12" class="box-2">
            <el-collapse-item title="Biểu đồ có mặt tại công ty tháng" name="2" class="chart">
              <template slot="title">
                <h6 class="ml-1 title-chart bold">Biểu đồ có mặt tại công ty tháng</h6>
              </template>
              <div @click="fn_goToEntryAndExitHistoryCompanyList">
                <ChartJS
                  v-if="loaded"
                  :idChart="'companyMonth'"
                  :typeChart="'bar'"
                  :chartdata="chartdataCompanyMonth"
                  :options="chartOptions"
                />
              </div>
            </el-collapse-item>
          </b-col>
          <b-col md="12" class="mt-3">
            <el-collapse-item name="3" class="chart last_sixMonth">
              <template slot="title">
                <h6 class="ml-1 title-chart bold">Biều đồ thông tin lương 6 tháng qua</h6>
              </template>
              <div @click="fn_goToSalaryPeriodList">
                <ChartJS
                  v-if="loaded"
                  :idChart="'Slary'"
                  :typeChart="'line'"
                  :chartdata="chartSlaryData"
                  :options="options"
                />
              </div>
            </el-collapse-item>
          </b-col>
        </b-row>
      </el-collapse>
      <b-row class="mb-3">
        <b-col xl="12">
          <div class="card box-card box-card__navigation mt-3">
            <h5 class="mb-2">Điều hướng nhanh</h5>
            <b-row class="row__navigation">
              <!-- <b-col md="3" sm="6" class="mt-2"> -->
              <el-button
                type="primary"
                round
                class="btn-default word-break-btn mb-2"
                @click="fn_go('WorkRequest')"
                >Thêm yêu cầu giải trình</el-button
              >
              <!-- </b-col>
              <b-col md="3" sm="6" class="mt-2"> -->
              <el-button
                type="primary"
                round
                class="btn-default word-break-btn mb-2"
                @click="fn_go('DayOffRequest')"
                >Thêm yêu cầu xin nghỉ</el-button
              >
              <!-- </b-col>
              <b-col md="3" sm="6" class="mt-2"> -->
              <el-button
                type="primary"
                round
                class="btn-default word-break-btn mb-2"
                @click="fn_go('WorkSheet')"
                >Bảng công</el-button
              >
              <!-- </b-col>
              <b-col md="3" sm="6" class="mt-2"> -->
              <el-button
                type="primary"
                round
                class="btn-default word-break-btn mb-2"
                @click="fn_go('OnlineRequest')"
                >Chấm công Online</el-button
              >
              <!-- </b-col> -->
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col xl="4" md="5" class="mb-3">
      <div class="box-shadow b-radius-15">
        <b-row>
          <!-- Start header calendar -->
          <HeaderCalendar :date="date" />
          <!-- End header calendar -->
          <b-col md="12" class="calendar">
            <Calendar
              :date="date"
            ></Calendar>
          </b-col>
          <!-- <b-col class="">
            <div class="card box-card box-card-radius" style="box-shadow: 0 0 0 0">
              <b-row>
                <b-col md="12" class="">
                  <div class="d-flex justify-content-between pl-1 pr-1">
                    <h5>TOP đi muộn trong tháng:</h5>
                    <b-link
                        style="text-decoration: underline"
                        class="bold ml-3"
                        href="javascript:"
                      >
                        Xem tất cả
                    </b-link>
                  </div>
                  <div style="border-bottom: 1px solid #bbb" class="mt-2 mb-3"></div>
                  <div class="mt-2 card-list-go-late">
                    <div
                      class="d-flex align-items-center"
                      v-for="(item, index) in mData.dataDefault.listEmployeeGoLate"
                      :key="index"
                    >
                      <div class="icon__avt-circle"></div>
                      <p style="max-width: 70%">{{ item.employee_no }} - {{ item.employee_name }}</p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col> -->
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import DashboardModel from './DashboardModel';
import SalaryApi from "../../../moduleApi/SalaryApi";
import SalaryPeriodApi from "../../../moduleApi/SalaryPeriodApi";
import TimeKeepingRawCurrentApi from "../../../moduleApi/TimeKeepingRawCurrentApi";
import EmployeeRequestApi from '../../../moduleApi/EmployeeRequestApi';
import EmployeeShiftApi from '../../../moduleApi/EmployeeShiftApi';
import MethodService from "../../../service/MethodService";
import Loading from "../../../component/Loading";
import HeaderCalendar from "./HeaderCalendar.vue";
import ChartJS from "@/component/ChartJs/ChartJS";
import EChart from '@/component/EChart/EChart'
import Calendar from "@/component/Calendar";
import EventBus from '@/service/EventBus';

export default {
  components: {
    Loading,
    HeaderCalendar,
    Calendar,
    ChartJS,
    EChart
  },
  props: {
    viewType: {
      type: String,
      default: undefined
    },
    shiftId: {
      type: String,
      default: null,
    },
    employeeShift: {
      type: Array,
      default: () => {[]},
    },
    shiftInfo: {
      type: Object,
      default: () => {},
    },
    listEmployee: {
      type: Array,
      default: () => {[]},
    },
    listRequest: {
      type: Array,
      default: () => {[]},
    },
  },
  data() {
    return {
      listEmployeeProp: this.listEmployee,
      date: new Date(),
      loaded: true,
      activeNames: ["1", "2", "3"],
      chartdataEventMonth: {},
      chartdataCompanyMonth: {},
      chartSlaryData: MethodService.copyObject(DashboardModel.chartSlaryData),
      optionChartEventMonth: DashboardModel.optionChartEventMonth,
      newDataProp: false,
      chartOptions: {
        legend: false,
        tooltip: false,
        responsive: true,
        interaction: {
          mode: "index",
          intersect: false,
        },
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
      nowDate: new Date().getDate(),
      options: {
        legend: false,
        tooltip: false,
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: "index",
          intersect: false,
        },
        stacked: false,
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            display: false,
          },
        },
        scales: {
          y: {
            type: "linear",
            display: true,
            position: "right",
            title: {
              display: window.innerWidth <= 547 ? false : true,
              text: "Tổng lương",
            },
          },
          y1: {
            type: "linear",
            display: true,
            position: "left",
            grid: {
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
            title: {
              display: window.innerWidth <= 547 ? false : true,
              text: "Số người",
            },
          },
        },
      },
      firstDayInMonth: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      lastDayInMonth: new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        1
      ).toISOString(),
      mData: {
        totalBusiness: 0,
        totalDayOff: 0,
        totalOnline: 0,
        totalGoLate: 0,
        totalOnTime: 0,
        company: {},
        dataDefault: {
          listEmployeeGoLate: [],
          listEmployeeShift: [],
          listTimeKeepingRaw: [],
          listEmployeeRequestFilterDayOff: [],
          listEmployeeRequestFilterOnline: [],
          listEmployeeRequestFilterBussiness: [],
          listEmployeeNoNeedCheckin: [],
          listEmployeeRequestFilterGoLate: []
        },
      },
    };
  },
  methods: {
    resetCountRequest() {
      this.mData.totalDayOff = 0;
      this.mData.totalOnline = 0;
      this.mData.totalBusiness = 0;
      this.mData.totalGoLate = 0;
      this.mData.totalOnTime = 0;
    },
    async fn_initData() {
      this.resetCountRequest();
      this.loaded = false;
      let now = new Date();
      this.year = now.getFullYear();
      this.month = now.getMonth() + 1;
      let dataFilterSalary = {
        cId: this.mData.company.id,
        limit: 6,
        skip: 0,
      };
      let dataFilterTimeKeepingRaw = {
        filters: "time>=" + this.firstDayInMonth + "&time<=" + this.lastDayInMonth,
        limit: 9999999,
        sort: "-time",
      };
      try {
        const salaryApiReq = SalaryApi.salaryStatistics(dataFilterSalary, true);
        const timeKeepingRawApiReq = TimeKeepingRawCurrentApi.list(
          dataFilterTimeKeepingRaw
        );
        const listDayOff = await EmployeeRequestApi.CalcNumberOfDayOffOfEmployee({
          from_date: MethodService.getFirstDayOfMonth(new Date()),
          to_date: MethodService.getLastDayOfMonth(new Date()),
          shift_id: this.shiftId,
        })
        this.mData.totalDayOff = listDayOff.result

        const salaryApiRes = await salaryApiReq;
        const timeKeepingRawApiRes = await timeKeepingRawApiReq;
        this.mData.dataDefault.listEmployeeNoNeedCheckin = this.fn_checkNoTimekeepingRequired(
          this.employeeShift
        );
        this.fn_changeDataSalaryChart(salaryApiRes.result);
        this.fn_changeDataRequest(this.listRequest)
        console.log('timeKeepingRawApiRes.result', timeKeepingRawApiRes.result);
        if (timeKeepingRawApiRes.result && timeKeepingRawApiRes.result.length > 0) {
          this.mData.dataDefault.listTimeKeepingRaw = timeKeepingRawApiRes.result.filter((item,index) => {
            let checkEmployeeInShift = this.listEmployeeProp.find(employee => employee.employee_no === item.employee_no)
            return checkEmployeeInShift ? true : false
          })
          this.mData.dataDefault.listTimeKeepingRaw = _.uniqBy(this.mData.dataDefault.listTimeKeepingRaw, (x) =>
            [x.employee_no, x.time].join()
          );
          this.calcNumberCompanyPresence(this.mData.dataDefault.listTimeKeepingRaw)
          let arrEmployeeCheckInHave = [];

          let promises = this.mData.dataDefault.listTimeKeepingRaw.map(async (item) => {
            let checkHaveEmployee = arrEmployeeCheckInHave.find(x =>
              x.employee_no == item.employee_no && x.date == new Date(item.time).getDate()
            )
            if (checkHaveEmployee) return;
            arrEmployeeCheckInHave.push({
              employee_no: item.employee_no,
              date: new Date(item.time).getDate()
            })
            return await this.fn_checkOnTime(new Date(item.time).getDay() + 1, new Date(item.time).getDate(), new Date(item.time).getMonth() + 1, new Date(item.time).getFullYear(), item.employee_no, item.time);
          });

          Promise.all(promises).then((values) => {
            this.mData.totalOnTime = values.filter((x) => x).length;
            this.mData.totalGoLate = values.filter((x) => x != undefined && x === false).length;
            this.mData.totalMissFace =
              this.mData.totalBusiness + this.mData.totalDayOff + this.mData.totalOnline;
            let checkValueUndefined = values.filter(e => e == undefined);
            if (checkValueUndefined.length != values.length) {
              this.mData.totalHaveFace = this.mData.totalOnTime + this.mData.totalGoLate;
            } else {
              this.mData.totalHaveFace =  0;
            }
            setTimeout(() => {
              this.fn_setDataChart();
              this.$emit('done')
            }, 1000);
          });
        } else {
          setTimeout(() => {
            this.fn_setDataChart();
          }, 1000);
        }
      } catch (error) {
        console.log(error);
      }

      // this.fn_setDataChart();
    },
    async calcNumberCompanyPresence(listTimeKeepingRaw) {
      let arrEmployeeHaveCheckIn = []
      let totalCheckIn = await this.getTotalWorkDayCheckInInMonth()
      let promises = listTimeKeepingRaw.map(async (item) => {
        let checkHaveEmployee = arrEmployeeHaveCheckIn.find(x =>
          x.employee_no == item.employee_no && x.date == new Date(item.time).getDate()
        )
        if (checkHaveEmployee) return
        arrEmployeeHaveCheckIn.push({
          employee_no: item.employee_no,
          date: new Date(item.time).getDate()
        })
      })
      // console.log('arrEmployeeHaveCheckIn', arrEmployeeHaveCheckIn)
      this.mData.totalHaveFace = arrEmployeeHaveCheckIn.length
      this.mData.totalMissFace = totalCheckIn - arrEmployeeHaveCheckIn.length
    },
    async getTotalWorkDayCheckInInMonth() {
      const resApi = await EmployeeShiftApi.calcNumberOfWorkDays({
        from_date: MethodService.getFirstDayOfMonth(new Date()),
        to_date: new Date(),
        shift_id: this.shiftId,
      })
      let totalCheckIn = this.listEmployeeProp.length * resApi.result
      return totalCheckIn
    },
    resetDataChartSalary(){
      this.chartSlaryData = MethodService.copyObject(DashboardModel.chartSlaryData);
    },
    fn_changeDataSalaryChart(data) {
      this.resetDataChartSalary();
      if (!data || data.length == 0) return;
      let promises = data.map(async (salary) => {
        let salaryPeriodApiRes = await SalaryPeriodApi.findById(salary.id);
        return salaryPeriodApiRes.result;
      });
      Promise.all(promises).then((values) => {
        data.forEach((item, index) => {
          item.name = values[index].name;
          item.from_date = values[index].from_date;
        });
        const salarySort = data.sort(function (a, b) {
          return new Date(a.from_date).getTime() - new Date(b.from_date).getTime();
        });
        salarySort.forEach((item, index) => {
          this.chartSlaryData.labels.push(item.name);
          this.chartSlaryData.datasets[0].data.push(item.total);
          this.chartSlaryData.datasets[1].data.push(item.count_employee);
        });

        // this.chartSlaryData.datasets[0].data = [100000,400000,null,500000,450000,550000];
      });
    },
    fn_changeDataRequest(data) {
      let listEmployeeRequestFilter = data.filter((item) => {
        return (
          (item.type == "DAY_OFF" && item.status == "APPROVED") ||
          (item.type == "GO_ON_BUSSINESS" && item.status == "APPROVED") ||
          (item.type == "TIME_KEEPING_ONLINE" && item.status != "REJECTED") ||
          (item.type == "GO_LATE" && item.status == "APPROVED")
        );
      });
      listEmployeeRequestFilter.forEach((item) => {
        if (item.type == "GO_ON_BUSSINESS" && item.status == "APPROVED") {
          this.mData.dataDefault.listEmployeeRequestFilterBussiness.push(item);
          this.mData.totalBusiness++;
        }
        // if (item.type == "DAY_OFF" && item.status == "APPROVED") {
        //   let dayOffShift = item.day_off.find(
        //     (e) =>
        //       e.shift_id == this.shiftId
        //   );
        //   if (
        //     dayOffShift &&
        //     ((dayOffShift.odd_shifts.length == 1 && dayOffShift.odd_shifts[0] == 1) ||
        //       (dayOffShift.odd_shifts.length == 2 &&
        //         ((dayOffShift.odd_shifts[0] == 1 && dayOffShift.odd_shifts[1] == 1) ||
        //           (dayOffShift.odd_shifts[0] == 0 && dayOffShift.odd_shifts[1] == 1) ||
        //           (dayOffShift.odd_shifts[0] == 1 && dayOffShift.odd_shifts[1] == 0))))
        //   ) {
        //     this.mData.dataDefault.listEmployeeRequestFilterDayOff.push(item);
        //     this.mData.totalDayOff++;
        //   }
        // }
        if (item.type == "TIME_KEEPING_ONLINE" && item.status != "REJECTED") {
          this.mData.dataDefault.listEmployeeRequestFilterOnline.push(item);
          this.mData.totalOnline++;
        }
        if (item.type == "GO_LATE" && item.status == "APPROVED") {
          this.mData.dataDefault.listEmployeeRequestFilterGoLate.push(item);
        }
      });
    },
    fn_setDataChart() {
      this.chartdataEventMonth = {
        labels: [ "Đúng giờ", "Đi muộn", "Công tác", "Nghỉ phép", "Online"],
        datasets: [
          {
            borderWidth: 0,
            label: ["Biểu đồ sự kiện trong tháng"],
            borderColor: ["#29ff98", "#F79D61", "#00D1FF", "#FF5A5A", "#6600FF"],
            backgroundColor: ["#29ff98", "#F79D61", "#00D1FF", "#FF5A5A", "#6600FF"],
            data: [
              this.mData.totalOnTime,
              this.mData.totalGoLate,
              this.mData.totalBusiness,
              this.mData.totalDayOff,
              this.mData.totalOnline,
            ],
          },
        ],
      };
      console.log('this.chartdataEventMonth', this.chartdataEventMonth);
      this.chartdataCompanyMonth = {
        labels: ["Vắng mặt", "Có mặt"],

        datasets: [
          {
            borderWidth: 0,
            label: "",
            borderColor: ["#616161", "#29ff98"],
            backgroundColor: ["#616161", "#29ff98"],
            data: [this.mData.totalMissFace, this.mData.totalHaveFace],
          },
        ],
      };
      console.log('this.chartdataCompanyMonth', this.chartdataCompanyMonth);
      this.loaded = true;
    },
    async fn_checkOnTime(dayOfWeek, dateCheckIn, monthCheckIn, yearCheckin, employeeNo, timeCheckIn) {
      let check = true;
      let workDay = undefined;
      let dayOffFullDay = false;
      let dayOffFirstOddShift = false;
      let dayOffSeconOddShift = false;
      let haveDayOff = false;
      let firstTimeLog = undefined;
      let firstTimeOfShift = undefined;
      let endTimeOfShift = undefined;
      let endTimeShiftDay = undefined;
      //Check có yêu cầu đi muộn của ngày đi làm đấy hay không
      let checkHaveRequestGoLate = this.mData.dataDefault.listEmployeeRequestFilterGoLate.find(request =>
        request.employee_no == employeeNo &&
        new Date(request.extra_minute_go_late).getDate() == dateCheckIn &&
        new Date(request.extra_minute_go_late).getMonth() == monthCheckIn &&
        new Date(request.extra_minute_go_late).getFullYear() == yearCheckin
      );
      //Check dayoff thuộc loại nghỉ nào
      let checkDayOff = this.mData.dataDefault.listEmployeeRequestFilterDayOff.find(dayOff => {
        return dayOff.employee_no == employeeNo;
      })
      if (checkDayOff) {
        haveDayOff = true;
        let checkDayoffOddDay = checkDayOff.day_off.find(c => {
          return c.shift_id == this.shiftId
        })
        if (checkDayoffOddDay) {
          if (
              (checkDayoffOddDay.odd_shifts.length == 1 && checkDayoffOddDay.odd_shifts[0] == 1) ||  //Check nếu odd_shift có dộ dài bằng 1 và phần tử đầu tiên == 1 => nghỉ cả ngảy
              (checkDayoffOddDay.odd_shifts.length == 2 && checkDayoffOddDay.odd_shifts[0] == 1 && checkDayoffOddDay.odd_shifts[1] == 1 )
            ) {
            dayOffFullDay = true;
            dayOffFirstOddShift = false;
            dayOffSeconOddShift = false;
          } else if (checkDayoffOddDay.odd_shifts.length == 2 && checkDayoffOddDay.odd_shifts[0] == 0 && checkDayoffOddDay.odd_shifts[1] == 1) {
            dayOffFullDay = false;
            dayOffFirstOddShift = false;
            dayOffSeconOddShift = true;
          } else if (checkDayoffOddDay.odd_shifts.length == 2 && checkDayoffOddDay.odd_shifts[0] == 1 && checkDayoffOddDay.odd_shifts[1] == 0) {
            dayOffFullDay = true;
            dayOffFirstOddShift = true;
            dayOffSeconOddShift = false;
          }
        }
      }
      if (haveDayOff === true && dayOffFullDay === true) {
        check = undefined;
        return
      }

      //Check Có Employee này trong ca này không
      let haveEmployee = this.listEmployeeProp.find(x => {
        return x.employee_no == employeeNo;
      });
      //Nếu không tồn tại nhân viên đấy trong ca thì bỏ qua luôn
      if (!haveEmployee) return;

      //Truyền thêm vào thời gian bắt đầu của ca, sau đó so sánh giờ
      if (this.shiftInfo.work_days && this.shiftInfo.work_days.length > 0) {
        workDay = this.shiftInfo.work_days.find(x =>
          ((x.period_time &&
            x.period_time[0] &&
            x.period_time[0].start_time &&
            x.period_time[0].start_time.hour) ||
            (x.period_time &&
              x.period_time[0] &&
              x.period_time[0].start_time &&
              !x.period_time[0].start_time.hour &&
              x.period_time &&
              x.period_time[1] &&
              x.period_time[1].start_time &&
              x.period_time[1].start_time.hour)) &&
          x.name == dayOfWeek
        );
      }
      if (workDay != undefined) {
        //Lấy giờ kết thúc của ca
        endTimeShiftDay = this.fn_getendTimeShiftDay(workDay);
        //Check giờ bắt đầu/kết thúc của từng ca lẻ
        let timeStartAndEndtime = this.fn_getFirstTimeAndEndTimeOfShift(workDay, haveDayOff, dayOffSeconOddShift, dateCheckIn);
        firstTimeOfShift = timeStartAndEndtime[0];
        endTimeOfShift = timeStartAndEndtime[1];
        if (checkHaveRequestGoLate) {
          firstTimeOfShift = checkHaveRequestGoLate.extra_minute_go_late;
        }
        //Nếu thời gian check in lớn hơn giờ bắt đầu của ca thì đi muộn và ngược lại
        firstTimeLog = await this.fn_getFistLogByDay(employeeNo, firstTimeOfShift);
        let currentTime = new Date().setDate(dateCheckIn)
        if (haveDayOff === true && dayOffFirstOddShift === true && (currentTime > new Date(firstTimeOfShift).getTime() && currentTime < new Date(endTimeOfShift).getTime())) {
          check = undefined;
          return
        } else if (haveDayOff ===true && dayOffSeconOddShift === true && (currentTime > new Date(endTimeOfShift).getTime())) {
          check = undefined;
          return
          // check
        }
        // lấy số lượng nhân viên có mặt
        if (
          (new Date(firstTimeLog).getTime() < currentTime) &&
          (new Date(firstTimeLog).getTime() < new Date(endTimeShiftDay).getTime())
        ) {
          this.mData.totalHaveFace++
        }
        if (
          !firstTimeLog ||
          (new Date(firstTimeLog).getTime() > new Date(firstTimeOfShift).getTime())
        ) {
          check = false
        }
      }
      return check;
    },
    fn_getendTimeShiftDay(workDay){
      let endTimeShiftDay = undefined;
      if (
        (workDay.period_time &&
        workDay.period_time[0] &&
        workDay.period_time[0].start_time &&
        workDay.period_time[0].start_time.hour) &&
        (workDay.period_time &&
        workDay.period_time[1] &&
        workDay.period_time[1].start_time &&
        workDay.period_time[1].start_time.hour)
      ) {
        endTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[1].end_time.hour, workDay.period_time[1].end_time.minute + 1);
      } else {
        endTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].end_time.hour, workDay.period_time[0].end_time.minute + 1);
      }
      return endTimeShiftDay
    },
    fn_getFirstTimeAndEndTimeOfShift(workDay, haveDayOff, dayOffSeconOddShift, dateCheckIn){
      let firstTimeOfShift = undefined;
      let endTimeOfShift = undefined;
      if (
        (workDay.period_time &&
        workDay.period_time[0] &&
        workDay.period_time[0].start_time &&
        workDay.period_time[0].start_time.hour) && haveDayOff == false
      ) {
        firstTimeOfShift = new Date(this.year, this.month - 1, new Date(new Date().setDate(dateCheckIn)).getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].start_time.minute + 1);
        endTimeOfShift = new Date(this.year, this.month - 1, new Date(new Date().setDate(dateCheckIn)).getUTCDate(), workDay.period_time[0].end_time.hour, workDay.period_time[0].end_time.minute + 1);
      } else if (
        (workDay.period_time &&
        workDay.period_time[0] &&
        workDay.period_time[0].start_time &&
        workDay.period_time[0].start_time.hour) && haveDayOff == true && dayOffSeconOddShift === true
      ) {
        firstTimeOfShift = new Date(this.year, this.month - 1, new Date(new Date().setDate(dateCheckIn)).getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].start_time.minute + 1);
        endTimeOfShift = new Date(this.year, this.month - 1, new Date(new Date().setDate(dateCheckIn)).getUTCDate(), workDay.period_time[0].end_time.hour, workDay.period_time[0].end_time.minute + 1);
      } else {
        firstTimeOfShift = new Date(this.year, this.month - 1, new Date(new Date().setDate(dateCheckIn)).getUTCDate(), workDay.period_time[1].start_time.hour, workDay.period_time[1].start_time.minute + 1);
        endTimeOfShift = new Date(this.year, this.month - 1, new Date(new Date().setDate(dateCheckIn)).getUTCDate(), workDay.period_time[1].end_time.hour, workDay.period_time[1].end_time.minute + 1);
      }
      return [firstTimeOfShift, endTimeOfShift]
    },
    fn_checkNoTimekeepingRequired(arrEmployeeShift) {
      let arrNoNeedCheckin = [];
      let arr = [];
      arr = arrEmployeeShift.filter((x) => {
        return x.is_need_checkin === false;
      });
      arr.forEach((y) => {
        let checkExist = arrNoNeedCheckin.find((z) => {
          return z.employee_id == y.employee_id;
        });
        let employee = this.listEmployeeProp.find((i) => {
          return i.id == y.employee_id;
        });
        if (!checkExist) {
          if (employee) {
            y.employee_no = employee.employee_no;
            arrNoNeedCheckin.push(y);
          }
        }
      });
      return arrNoNeedCheckin;
    },
    fn_getFistLogByDay(employeeNo, firstTimeOfShift) {
      let timeBefore = undefined;
      let timeAfter = undefined;
      let arrTimeBefore = this.mData.dataDefault.listTimeKeepingRaw.filter((item) => {
        return (
          item.employee_no == employeeNo &&
          new Date(item.time).getTime() < new Date(firstTimeOfShift).getTime() &&
          new Date(item.time).getDate() == new Date(firstTimeOfShift).getDate()
        );
      });
      timeBefore = this.sortTimeDesc(arrTimeBefore)[0];
      let arrTimeAfter = this.mData.dataDefault.listTimeKeepingRaw.filter((item) => {
        return (
          item.employee_no == employeeNo &&
          new Date(item.time).getTime() > new Date(firstTimeOfShift).getTime() &&
          new Date(item.time).getDate() == new Date(firstTimeOfShift).getDate()
        );
      });
      timeAfter = this.sortTimeAsc(arrTimeAfter)[0];
      return timeBefore != undefined
        ? timeBefore.time
        : timeAfter != undefined
        ? timeAfter.time
        : undefined;
    },
    //Sort giảm dần
    sortTimeDesc(arr) {
      return arr.sort(function (a, b) {
        return new Date(b.time).getTime() - new Date(a.time).getTime();
      });
    },
    //Sort tăng dần
    sortTimeAsc(arr) {
      return arr.sort(function (a, b) {
        return new Date(a.time).getTime() - new Date(b.time).getTime();
      });
    },
    fn_go(type) {
      if (type == "EmployeeList") {
        this.$router.push({
          name: "Admin-EmployeeManager-list",
        });
      } else if (type == "EmployeeRequestNeedApprove") {
        this.$router.push({
          name: "Admin-ManageRequests-RequestsWaitingForApproval",
        });
      } else if (type == "WorkRequest") {
        this.$router.push({
          name: "Admin-ManageRequests-ListRequests-WorkAdditionRequests",
        });
      } else if (type == "DayOffRequest") {
        this.$router.push({
          name: "Admin-ManageRequests-ListRequests-DayOffRequests",
        });
      } else if (type == "WorkSheet") {
        this.$router.push({
          name: "Admin-Timekeeping-Worksheet",
        });
      } else if (type == "OnlineRequest") {
        this.$router.push({
          name: "Admin-ManageRequests-ListRequests-TimeKeepingOnlineRequests",
        });
      }
    },
    refreshData() {
      this.fn_initData();
      window.setTimeoutZ = setTimeout(() => {
        this.refreshData();
      }, 1000 * 300); //5 phút
    },
    fn_goToEntryAndExitHistoryCompanyList() {
      this.$router.push({
        name: "Admin-Timekeeping-TimekeepingConfig-EntryAndExitHistoryCompanyList",
        query: {
          fromTime: new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(0,0,0)).toISOString(),
          toTime: new Date(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).setHours(0,0,0)).toISOString(),
        }
      }).catch(() => {});
    },
    fn_goToSalaryPeriodList() {
      this.$router.push({
        name: "Admin-Salary-SalaryPeriod-SalaryPeriodList",
      }).catch(() => {});
    },
  },

  watch: {
    listEmployee(newVal) {
      this.listEmployeeProp = newVal
      if (window.setTimeoutZ) clearTimeout(window.setTimeoutZ)
      this.refreshData()
    },
    viewType(newVal) {
      console.log('newVal', newVal)
    }
  },
  created() {
    this.mData.company = MethodService.getCompanyInfo();
    if (window.setTimeoutZ) clearTimeout(window.setTimeoutZ)
    this.refreshData()
  },
  mounted() {
    $(".chart .el-collapse-item__wrap").click(function() {
      this.fn_goToEntryAndExitHistoryCompanyList();
    }.bind(this));
    $(".chart.last_sixMonth .el-collapse-item__wrap").click(function() {
      this.fn_goToSalaryPeriodList();
    }.bind(this));
  },
};
</script>

<style scoped>
::v-deep .vc-highlight {
  background-color: #f79e61 !important;
}
.row {
  margin-left: -15px;
  margin-right: -15px;
}
.vc-container {
  border-color: #fff;
  border-radius: 0;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
.row__navigation {
  justify-content: space-between;
}
.box-card__navigation {
  padding: 25px !important;
}
.box-card-radius {
  border-radius: 0 0 15px 15px !important;
}
.icon__avt-circle {
  min-width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #757575;
  margin: 5px 20px;
}
.title-chart {
  color: #1e2027;
}
.word-break-btn {
  max-width: 250px;
  width: 210px;
  height: 50px;
  text-transform: none;
  font-size: 13px;
  white-space: normal;
  padding: 5px 5px;
}
.al-center {
  align-items: center;
}
.div_btn {
  padding: 10px;
  width: 200px;
  height: 45px;
  background: var(--white);
  box-shadow: 0px 0px 20px rgba(43, 43, 43, 0.131);
  border-radius: 25px;
}
.d-flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fake_btn {
  width: 100%;
  padding: 5px;
  text-align: center;
  background: #fdfdfd;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.049);
  border-radius: 25px;
}
.fake_btn.active {
  background-color: rgb(60, 189, 248);
  color: #fff;
  letter-spacing: 0.01em;
  font-weight: 500;
  font-size: 12px;
  /* line-height: 14px; */
}
.fake_btn:hover {
  cursor: pointer;
}
.fake_btn span {
  font-size: 15px;
  font-weight: 400;
}
.panel-group .card-panel {
  border-radius: 10px;
  height: 110px;
  cursor: pointer;
  font-size: 15px;
  position: relative;
  overflow: hidden;
  color: #666;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  border-color: #c0c4cc;
}
.title-box_card {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 600;
  line-height: 32px;
  position: absolute;
  top: 10px;
  left: 20px;
}
.icon {
  position: absolute;
  top: 30%;
  right: 10px;
}
.icon i {
  font-size: 35px;
}
.count {
  position: absolute;
  bottom: 15%;
  left: 20px;
  font-size: 35px;
  font-weight: bold;
}
.box-shadow {
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
}
.card.box-card {
  padding: 15px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
  border-color: #c0c4cc;
  background: #fff;
}
.card-list-go-late {
  max-height: 200px;
  overflow: auto;
}
.el-button + .el-button {
  margin-left: 0;
}
::v-deep .calendar {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
::v-deep .header_css,
.calendar {
  padding-left: 0 !important;
  padding-right: 0 !important;
  line-height: normal;
}
::v-deep .el-collapse {
  border-top-color: transparent;
  border-top-width: 0;
  border-bottom-color: transparent;
  border-bottom-width: 0;
}
::v-deep .el-collapse .el-collapse-item__header {
  background-color: var(--white);
  border: 1px solid #c8ced3;
}
::v-deep .el-collapse .el-collapse-item__content {
  border: 1px solid #c8ced3;
  border-top-width: 0;
}
@media (max-width: 992px) {
  .box-2 {
    margin-top: 10px;
  }
}
@media (max-width: 768px) {
  .calendar {
    margin-top: 10px;
  }
}
@media (max-width: 1660px) and (min-width: 1421px) {
  .word-break-btn {
    width: 170px;
  }
}
@media (max-width: 1420px) and (min-width: 1114px) {
  .word-break-btn {
    width: 135px;
  }
}
@media (max-width: 1114px) and (min-width: 1040px) {
  .word-break-btn {
    width: 180px;
  }
}
@media (max-width: 1039px) and (min-width: 768px) {
  .word-break-btn {
    width: 120px;
  }
}
@media (max-width: 547px) {
  .word-break-btn {
    width: 100%;
  }
  .row__navigation {
    flex-direction: column;
    align-items: center;
  }
}
</style>
